export function main() {
  
  
  if ($(window).width() < 1024) {
    $('.main-calc .top-section__info h1').insertBefore('.top-calc');
  }

  if ($(window).width() < 1024) {
    $('.header__top-info .tel').insertBefore('.nav > ul');
  }

  $('.location-work__add-title').on('click', function() {
    $(this).toggleClass('active');
    $('.location-work__add-list').toggleClass('active');
  });

  $('.map__region-list .location-work__add-list .map__opener').on('click', function() {
    $('.location-work__add-list').toggleClass('active');
    $('.location-work__add-title').toggleClass('active');
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.location-work__add-title, .location-work__add-list').length) {
      $('.location-work__add-list').removeClass('active');
      $('.location-work__add-title').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.map__region-mobile-title').on('click', function() {
    $('.map__region-mobile-drop').toggleClass('active');
  });

  $('.map__region-mobile-drop .map__opener').on('click', function() {
    $('.map__region-mobile-drop').removeClass('active');
    $('.map__region-mobile-drop .map__opener').removeClass('active');
    $('.map__region-mobile-title').html($(this).text());
    $(this).addClass('active');
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.map__region-mobile-title, .map__region-mobile-drop').length) {
      $('.map__region-mobile-drop').removeClass('active');
    }
    e.stopPropagation();
  });

  $('.callback').on('click', function() {
    $('.popup-callback').addClass('active');
  });

  $(document).on('click', ".map-callback", function(e) {
    $('.popup-callback').addClass('active');
  });

  $('.popup__overlay, .popup__close').on('click', function() {
    $('.popup').removeClass('active');
    $('.popup-video iframe').attr('src', '');
  });

  $('.review__box--video').on('click', function(e) {
    e.preventDefault();
    var video = $(this).data('video');
    $('.popup-video').addClass('active');
    $('.popup-video iframe').attr('src', 'https://www.youtube.com/embed/' + video + '?autoplay=1');
  });

  $('.about-video__box').on('click', function(e) {
    e.preventDefault();
    var video = $(this).data('video'),
        iframe = $(this).find('iframe'),
        iframeSrc = iframe.attr('src');

      if(iframeSrc == ''){
        $(this).addClass('active');
        iframe.attr('src', 'https://www.youtube.com/embed/' + video + '?autoplay=1&rel=0');
      }
  });

  $('.review__btn').each(function(index, element) {
      $(element).on('click', function(e) {
          e.preventDefault();
          $("#result-name").html($(element).parents('.review__box').find('.review__name').html());
          $("#result-location").html($(element).parents('.review__box').find('.review__location').html());
          $("#result-text").html($(element).parents('.review__box').find('.review__text--hidden').html());
          $('.popup-review').addClass('active');
      })
  });

  $('.menu-opener').on('click', function() {
    $(this).toggleClass('active');
    $('.nav').toggleClass('active');
  });

  $('.icon-help').on('click', function() {
    $('.text-help').removeClass('active');
    $(this).siblings('.text-help').addClass('active');
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.help').length) {
      $('.text-help').removeClass('active');
    }
    e.stopPropagation();
  });

  if ($(window).width() < 1250) {
    $('.menu-item-has-children > a').on('click', function(e) {
      e.preventDefault();
      $('.sub-menu').toggleClass('active');
    });
  }else{
    $(document).on('scroll',function(){
      fixedTest(this)
    })
    function fixedTest(item){
      var windowWidth = $(window).width(),
          scrollTop = $(item).scrollTop();

      if(scrollTop >= 134){
        $('header').addClass('fixed');
      }else {
        $('header').removeClass('fixed');
      }
    }
    fixedTest(document)
  }

}



// WEBPACK FOOTER //
// app/scripts/components/main.js